module.exports = __webpack_public_path__ + "media/images/pic03-d77bb62fe5d5d1276f78876931a3a7d4.jpg";